//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '../../../lib/util';
import fileUploader from '../../common-components/file-uploader';

export default {
  name: 'owners',
  components: {
    fileUploader
  },
  data() {
    const vm = this;
    return {
      loading: false,
      pageSize: 20,
      currentPage: 1,
      totalCount: 0,
      searchInput: {},
      list: [],
      saving: false,
      cityList: [],
      projects: [],
      stages: [],
      showExpressImport: false,
      ownerImport: {
        businessType: 'OwnerImport',
        isModify: false,
        file: {associateType: 'OwnerImport'}
      },
      columns: [
        // {
        //     type: 'selection',
        //     align: 'center',
        //     width: 60
        // },
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: '城市名称',
          key: 'cityName',
          align: 'center',
          width: 99
        },
        {
          title: '项目名称',
          key: 'projectName',
          align: 'center',
          minWidth: 130
        },
        {
          title: '分期名称',
          key: 'projectStages',
          align: 'center',
          width: 99
        },
        {
          title: '楼栋号',
          key: 'roomStructureName',
          align: 'center',
          minWidth: 110
        },
        {
          title: '单元号',
          key: 'chamberName',
          align: 'center',
          width: 99
        },
        {
          title: '楼层',
          key: 'storeyName',
          align: 'center',
          width: 90
        },
        {
          title: '房号',
          key: 'roomNumber',
          align: 'center',
          width: 90
        },
        {
          title: '面积(㎡)',
          key: 'square',
          align: 'center',
          width: 90
        },
        {
          title: '户型',
          key: 'houseTypeName',
          align: 'center',
          width: 90
        },
        {
          title: '客户姓名', key: 'name', align: 'center', minWidth: 90,
          render: (h, params) => {
            const rom = params.row.roomOwnerOutput;
            return h('span', rom.name)
          }
        },
        {
          title: '客户证件号',
          // key: 'roomOwnerOutput.cardNum',
          width: 160,
          align: 'center',
          render: (h, params) => {
            const rom = params.row.roomOwnerOutput;
            return h('span', rom.cardNum)
          }
        },
        {
          title: '客户手机号',
          key: 'phoneNumber',
          width: 99,
          align: 'center',
          render: (h, params) => {
            const rom = params.row.roomOwnerOutput;
            return h('span', rom.phoneNumber)
          }
        },
        {
          title: '签约日期',
          key: 'purchaseDateStr',
          align: 'center',
          minWidth: 120
        },
        {
          title: '交房日期',
          key: 'deliveryDateStr',
          align: 'center',
          minWidth: 120
          // render: (h, params) => {
          //     if (params.row.deliveryDate) {
          //         return h('span', new Date(params.row.deliveryDate).toLocaleDateString());
          //     }
          // }
        },
        {
          title: '出证日期',
          key: 'issueDateStr',
          align: 'center',
          minWidth: 120
          // render: (h, params) => {
          //     if (params.row.issueDate) {
          //         return h('span', new Date(params.row.issueDate).toLocaleDateString());
          //     }
          // }
        },
        {
          title: '领证日期',
          key: 'receiveDateStr',
          align: 'center',
          minWidth: 120
          // render: (h, params) => {
          //     if (params.row.receiveDate) {
          //         return h('span', new Date(params.row.receiveDate).toLocaleDateString());
          //     }
          // }
        },
        {
          title: '业主',
          align: 'center',
          slot: 'member',
          width: 300
        },
        {
          title: '操作',
          minWidth: 100,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            const actions = [];

            let del = h('Button', {
              props: {
                type: 'error',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  vm.delOwner(params.row);
                }
              }
            }, '删除');


            let edit = h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  // vm.editOwner(params.row);
                  vm.$router.push({
                    name: 'owner-detail',
                    params: {
                      id: params.row.id
                    }
                  });

                }
              }
            }, '查看');
            // if (vm.hasPermission('Pages.ProjectManage.RoomAndOwner.Detail')) {
            actions.push(edit);
            // }
            // actions.push(del);
            return h('div', actions);
          }
        }
      ]
    };
  },
  methods: {
    pageChange(page) {
      this.currentPage = page;
      this.getPage();
    },
    pageSizeChange(pagesize) {
      this.pageSize = pagesize;
      this.getPage();
    },
    async getPage() {
      this.loading = true;
      this.searchInput.maxResultCount = this.pageSize;
      this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
      await abp.ajax.post('/api/services/app/NewOwner/Search', this.searchInput).then(res => {
        this.list = [];
        this.list.push(...res.data.result.items);
        this.totalCount = res.data.result.totalCount;
      }).finally(() => {
        this.loading = false;
      });
    },
    getCities() {
      this.$store.dispatch({
        type: 'city/getCityList'
      }).then(() => {
        this.cityList = this.$store.state.city.cityList;
        this.projects = [];
        for (let i = 0; i < this.cityList.length; i++) {
          this.projects.push(...this.cityList[i].projects);
        }

      });
    },
    citySelectChange(val) {
      if (parseInt(val) > 0) {
        // this.getProjects(parseInt(val));
        let select = this.cityList.filter(x => x.id === parseInt(val));
        this.projects = [];
        this.projects = select[0].projects;
      } else {
        this.projects = [];
        // this.getProjects();
        for (const i = 0; i < this.cityList.length; i++) {
          this.projects.push(...this.cityList[i].projects);
        }
      }
    },

    onProjectChange(value) {
      this.stages = [];
      let select = this.projects.filter(x => x.id === parseInt(value));
      this.stages = [];
      this.stages = select[0].stages;

    },
    goufangTimeChange(date) {
      this.searchInput.gfStartTime = date[0];
      this.searchInput.gfEndTime = date[1];
    },
    cretaeTimeChange(date) {
      this.searchInput.jfStartTime = date[0];
      this.searchInput.jfEndTime = date[1];
    },
    dataTransferTimeChange(date) {
      this.searchInput.dtStartTime = date[0];
      this.searchInput.dtEndTime = date[1];
    },
    dataTransferChange(val) {
      if (val === '是') {
        this.searchInput.isDataTransfer = true;
      } else if (val === '否') {
        this.searchInput.isDataTransfer = false;
      } else {
        this.searchInput.isDataTransfer = null;
      }
    },
    onOwnerTemplateExport() {
      let url = util.ApiUrl + 'ServiceReport/OwnerTemplateExport';
      window.open(url, '_blank');
    },
    onExpressImport() {
      let _arrId = this.ownerImport.file.addAttrIds;
      let _associateType = this.ownerImport.file.associateType;
      if (typeof (this.ownerImport.file.addAttrIds) == 'undefined') {
        this.$Notice.warning({
          title: '提示',
          desc: '请选择xlsx文件.'
        });
        // this.loading = false;
        return false;
      }
      this.saving = true;
      abp.ajax.post(util.ApiUrl + 'ServiceReport/OwnersImport?associateId=' + _arrId + '&associateType=' + _associateType, {}, {timeout: 60000})
          .then((res) => {
            this.$Message.info({
              duration: 15,
              content: res.data,
              closable: true
            });
            // this.$router.push('/project/Dashboard');
            this.showExpressImport = false;
            this.getPage();
          }).catch((error) => {
      }).finally(() => {
        this.saving = false;
      });
    },
    hasPermission(permission) {
      return abp.auth.isGranted(permission);
    },
    onOwnerExport() {
      let urlStr = '';

      if (this.searchInput.cityId) {
        urlStr = urlStr + '&cityId=' + this.searchInput.cityId;
      }
      if (this.searchInput.projectId) {
        urlStr = urlStr + '&projectId=' + this.searchInput.projectId;
      }
      if (this.searchInput.projectStages) {
        urlStr = urlStr + '&projectStages=' + encodeURIComponent(this.searchInput.projectStages);
      }

      if (this.searchInput.name) {
        urlStr = urlStr + '&name=' + encodeURIComponent(this.searchInput.name);
      }
      if (this.searchInput.cardNum) {
        urlStr = urlStr + '&cardNum=' + this.searchInput.cardNum;
      }
      if (this.searchInput.phoneNumber) {
        urlStr = urlStr + '&phoneNumber=' + this.searchInput.phoneNumber;
      }

      if (this.searchInput.roomNumber) {
        urlStr = urlStr + '&roomNumber=' + this.searchInput.roomNumber;
      }

      if (this.searchInput.gfStartTime) {
        urlStr = urlStr + '&gfStartTime=' + this.searchInput.gfStartTime;
      }
      if (this.searchInput.gfEndTime) {
        urlStr = urlStr + '&gfEndTime=' + this.searchInput.gfEndTime;
      }
      if (this.searchInput.jfStartTime) {
        urlStr = urlStr + '&jfStartTime=' + this.searchInput.jfStartTime;
      }
      if (this.searchInput.jfEndTime) {
        urlStr = urlStr + '&jfEndTime=' + this.searchInput.jfEndTime;
      }
      if (this.searchInput.dtStartTime) {
        urlStr = urlStr + '&dtStartTime=' + this.searchInput.dtStartTime;
      }
      if (this.searchInput.dtEndTime) {
        urlStr = urlStr + '&dtEndTime=' + this.searchInput.dtEndTime;
      }
      if (this.searchInput.isDataTransfer) {
        urlStr = urlStr + '&isDataTransfer=' + this.searchInput.isDataTransfer;
      }

      let url = util.ApiUrl + 'ServiceReport/RoomAndOwnersExport?' + urlStr;
      window.open(url, '_blank');
    }
  },
  created() {
    this.getPage();
    this.getCities();
    // this.getProjects();
  }
};
